<template>
    <span
        tabindex="0"
        :class="wrapClasses"
        @click="handleToggle"
        @keydown.space="handleToggle">
        <input type="hidden" :name="name" :value="currentValue">
        <span :class="innerClasses">
            <slot name="open" v-if="currentValue === trueValue"></slot>
            <slot name="close" v-if="currentValue === falseValue"></slot>
        </span>
    </span>
</template>
<script>
    import Emitter from '../../../mixins/emitter'
    import { oneOf } from '../../../utils/assist'

    const prefixCls = 'yy-switch'
    export default {
        name: 'YYSwitch',
        mixins: [ Emitter ],
        props: {
            value: {
                type: [String, Number, Boolean],
                default: false
            },
            shape: {
                validator(value) {
                    return oneOf(value, ['circle', 'square'])
                },
                default: 'circle'
            },
            trueValue: {
                type: [String, Number, Boolean],
                default: true
            },
            falseValue: {
                type: [String, Number, Boolean],
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            name: {
                type: String
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                currentValue: this.value
            }
        },
        computed: {
            wrapClasses () {
                return [
                    `${prefixCls}`,
                    {
                        [`${prefixCls}-checked`]: this.currentValue === this.trueValue,
                        [`${prefixCls}-disabled`]: this.disabled,
                        [`${prefixCls}-${this.shape}`]: !!this.shape,
                        [`${prefixCls}-loading`]: this.loading
                    }
                ]
            },
            innerClasses () {
                return `${prefixCls}-inner`
            }
        },
        watch: {
            value (val) {
                if (val === this.trueValue || val === this.falseValue) {
                    this.currentValue = val
                }
            }
        },
        methods: {
            handleToggle (event) {
                event.preventDefault()
                if (this.disabled || this.loading) return

                const checked = this.currentValue === this.trueValue ? this.falseValue : this.trueValue

                this.currentValue = checked
                this.$emit('input', checked)
                this.$emit('on-change', checked)
                this.dispatch('YYFormItem', 'on-form-change', checked)
            }
        }
    }
</script>
